import { render, staticRenderFns } from "./WorkspaceFabricPlaneGrouping.vue?vue&type=template&id=06e16a5e&scoped=true&"
import script from "./WorkspaceFabricPlaneGrouping.vue?vue&type=script&lang=js&"
export * from "./WorkspaceFabricPlaneGrouping.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceFabricPlaneGrouping.vue?vue&type=style&index=0&id=06e16a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e16a5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06e16a5e')) {
      api.createRecord('06e16a5e', component.options)
    } else {
      api.reload('06e16a5e', component.options)
    }
    module.hot.accept("./WorkspaceFabricPlaneGrouping.vue?vue&type=template&id=06e16a5e&scoped=true&", function () {
      api.rerender('06e16a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/WorkspaceFabricPlaneGrouping.vue"
export default component.exports